<template>
  <div class="v-base app" style="margin: 0">
    <div class="kingfisher-login-box">
      <div class="kingfisher-logo-box">
        <div class="kingfisher-login-con" v-if="showApply">
          <div class="kingfisher-login-title">申请</div>
          <div class="kingfisher-login-title2">apply</div>
          <el-form class="kingfisher-login-input mt20" :rules="userInfoRules" :model="userInfo">
            <p class="error">{{ model.data.message }}</p>
            <el-form-item
                style="width: 100%;" class="wel_input_box"
                prop="name">

              <el-input
                  v-model="userInfo.name" placeholder="请输入姓名"
                  type="text"
                  @keydown.enter="loginFromKey" @change="onChange">
                <template><i class="iconfont  icon-user"></i></template>
              </el-input>
            </el-form-item>
            <el-form-item style="width: 100%;margin-top: 1rem" class="wel_input_box" prop="company">
              <el-input v-model="userInfo.company"
                        placeholder="请输入公司"  @keydown.enter="loginFromKey"
                        @change="onChange">
                <template><i class="iconfont icon-mima"></i></template>
              </el-input>
            </el-form-item>
            <el-form-item style="width: 100%;margin-top: 1rem" class="wel_input_box" prop="phone">
              <el-input v-model="userInfo.phone"
                        placeholder="请输入电话"  @keydown.enter="loginFromKey"
                        @change="onChange">
                <template><i class="iconfont icon-mima"></i></template>
              </el-input>
            </el-form-item>
            <el-form-item style="width: 100%;margin-top: 1rem" class="wel_input_box" prop="email">
              <el-input v-model="userInfo.email"
                        placeholder="请输入邮箱"  @keydown.enter="loginFromKey"
                        @change="onChange">
                <template><i class="iconfont icon-mima"></i></template>
              </el-input>
            </el-form-item>
            <el-form-item style="width: 100%;margin-top: 1rem" class="wel_input_box" prop="position">
              <el-input v-model="userInfo.position"
                        placeholder="请输入职务"  @keydown.enter="loginFromKey"
                        @change="onChange">
                <template><i class="iconfont icon-mima"></i></template>
              </el-input>
            </el-form-item>
            <div class="login_btn_box"
                 style="width: 100%;margin-top: 1.5rem;display: flex;flex-direction: row;justify-content: space-between;align-items: center">
              <!--            <el-form-item>-->
              <!--              <el-checkbox class="rem" v-model="user.rememberMe">记住密码</el-checkbox>-->
              <!--            </el-form-item>-->

              <el-button class="wx_btn" round @click="showApply=false">返回</el-button>
              <el-button type="warning" round @click="doSubmit" :loading="model.data.tryLogin">提交</el-button>
            </div>
          </el-form>
        </div>
        <div class="kingfisher-login-con" v-if="!showApply">
          <div class="kingfisher-login-title">{{ siteName }}</div>
          <div class="kingfisher-login-title2">{{ siteEnName }}</div>
          <div class="kingfisher-wx-qr-box" v-if="wxQrLogin">
            <div class="qr-view" id="wxQrLogin"></div>
            <div class="kingfisher-wx-qr-btn" @click="doStopWxQrLogin">
              <i class="iconfont icon-xiangzuo" style="font-size: 20px;"></i>
            </div>
          </div>
          <el-form  class="kingfisher-login-input mt20" v-else :rules="model.data.rules" :model="model.data.user">
            <p class="error">{{ model.data.message }}</p>
            <el-form-item
                style="width: 100%;" class="wel_input_box"
                prop="username">

              <el-input
                  v-model="model.data.user.userName" placeholder="请输入账号"
                  type="text"
                  @keydown.enter="loginFromKey" @change="onChange">
                <template><i class="iconfont  icon-user"></i></template>
              </el-input>
            </el-form-item>
            <el-form-item style="width: 100%;margin-top: 1rem" class="wel_input_box" prop="password">
              <el-input v-model="model.data.user.password"
                        placeholder="请输入密码" type="password" @keydown.enter="loginFromKey"
                        @change="onChange">
                <template><i class="iconfont icon-mima"></i></template>
              </el-input>
            </el-form-item>
            <div class="login_btn_box"
                 style="width: 100%;margin-top: 1.5rem;display: flex;flex-direction: row;justify-content: space-between;align-items: center">
              <!--            <el-form-item>-->
              <!--              <el-checkbox class="rem" v-model="user.rememberMe">记住密码</el-checkbox>-->
              <!--            </el-form-item>-->
              <el-button type="warning" round @click="doLogin" :loading="model.data.tryLogin">登录</el-button>
              <el-button class="wx_btn" round @click="doWxQrLogin">微信登录</el-button>
              <el-button class="wx_btn apply_btn"  round @click="doApply">申请</el-button>
            </div>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getCurrentInstance, onMounted, ref} from 'vue'
import {useRoute, useRouter} from 'vue-router'
import {ElMessage} from 'element-plus'
import 'url-search-params-polyfill'
import {setToken} from "@/utils/auth";
import userModel from '../model/user'
import userService from '../service/user'

export default {
  name: 'Welcome',
  setup() {
    const router = useRouter();
    const route = useRoute();

    let timer;

    let model = ref({
      data: {
        tryLogin: false,
        rules: {
          userName: [
            {required: true, message: '用户名不能为空', trigger: 'blur'}
          ],
          password: [
            {required: true, message: '密码不能为空', trigger: 'blur'}
          ]
        },
        user: {
          userName: "",
          password: "",
          rememberMe: true
        },
        message: '',
        group: '',
        role: ''
      }
    });
    const wxQrLogin = ref(false);

    if (window.location.href.indexOf("http://localhost") === 0) {
      model.value.data.user.userName = "admin";
      model.value.data.user.password = "123456";
    }

    const doLogin = () => {
      if (!model.value.data.user.userName || !model.value.data.user.password) {
        ElMessage({type: 'warning', message: '用户名或密码不能为空'});
        return;
      }
      if (!model.value.data.tryLogin) {
        model.value.data.tryLogin = true;
        svsLogin();
      }
    };

    const doWxLogin = () => {
      userService.wxLogin(btoa(window.location.href)).then((res) => {
        if (res && res.kfSysCode === 0) {
          const wxLoginUrl = res.kfSysMsg
          if (wxLoginUrl && wxLoginUrl.startsWith('http')) {
            window.location.href = wxLoginUrl;
          } else {
            console.log(wxLoginUrl);
          }
        } else {
          console.log(res.kfSysMsg);
        }
      })
    }

    const doWxQrLogin = () => {
      wxQrLogin.value = true;
      window.Kf = window.Kf || {}
      window.Kf.onWxQrSuccess = (result) => {
        new WxLogin({
          id: 'wxQrLogin',
          appid: result.appId,
          scope: 'snsapi_login',
          redirect_uri: result.rdUrl,
          state: result.state,
        });
      };
      window.Kf.onWxQrFail = (msg) => {
        wxQrLogin.value = false;
        model.value.data.message = msg;
      };

      const qrLogin = () => {
        if (window.Kf.wechatLogin && window.Kf.ssoReady) {
          clearInterval(timer);
          window.Kf.wechatLogin();
        }
      }
      timer = setInterval(qrLogin, 50);
    }

    const doStopWxQrLogin = () => {
      const _dom = document.getElementById('wxQrLogin');
      if (_dom) {
        _dom.innerHTML = '';
      }
      wxQrLogin.value = false;
    }

    const svsLogin = (ticket) => {
      window.Kf = window.Kf || {}
      window.Kf.onLoginSuccess = (result) => {
        userModel.updateUser(result);
        setToken(result.kfSysMsg);
        localStorage.setItem('KC_USER', JSON.stringify(result.data));
        localStorage.setItem('KC_TOKEN', result.kfSysMsg);
        let resultData = result.data;
        model.value.data.tryLogin = false;
        if (resultData.userName) {
          const _path = window.location.origin + window.location.pathname;
          // router.replace({path: '/main'});
          window.location.href = _path + '#/main';
        }
      }
      window.Kf.onLoginFail = (result) => {
        model.value.data.tryLogin = false;
      }

      if (ticket) {
        localStorage.setItem('KC_TOKEN', ticket);
        let autoLogin = function() {
          if (window.Kf.login && window.Kf.ssoReady) {
            clearInterval(timer);
            window.Kf.login("", "");
          }
        }
        let timer = setInterval(autoLogin, 50);
      } else {
        let login = function() {
          if (window.Kf.login && window.Kf.ssoReady) {
            clearInterval(timer);
            window.Kf.login(model.value.data.user.userName, model.value.data.user.password);
          }
        }
        let timer = setInterval(login, 50);
      }
    }

    const loginFromKey = (event) => {
      if (event.keyCode === 13) {
        doLogin();
      }
    };
    const onChange = (value) => {
      model.value.data.tryLogin = false;
    };

    let swagger;

    const url = window.location.href;
    const params = new URLSearchParams(url.substring(url.indexOf('?') + 1));
    let ticket = params.get('ticket');

    if (ticket) {
      if (ticket.indexOf("#") !== -1) {
        ticket = ticket.substring(0, ticket.indexOf("#"));
        ticket = decodeURI(ticket);
      }
      svsLogin(ticket);
    } else if (route.params.ticket) {
      svsLogin(route.params.ticket);
    }

    let siteName = ref();
    let siteEnName = ref();

    onMounted(() => {
      console.log("项目初始化完成", getCurrentInstance());
      siteName.value = "翠鸟应用中心";
      siteEnName.value = "Kingfisher Portal"
      document.title = '翠鸟应用中心';
      let width = document.body.clientWidth;
      let fontSize = Math.floor(width / 1920 * 16);
      document.body.parentElement.style.fontSize = fontSize + "px";
    });

    let showApply=ref(false);
    let userInfo=ref({
    });
    let userInfoRules=ref({
      name: [
        {required: true, message: '姓名不能为空', trigger: 'blur'}
      ],
      company: [
        {required: true, message: '密码不能为空', trigger: 'blur'}
      ],
      phone: [
        {required: true, message: '密码不能为空', trigger: 'blur'}
      ]
    });
    const doApply=function () {
      showApply.value=true;
      userInfo.value={ name:'',
        company:'',
        phone :'',
        email:'',
        position:''
      }
    }

    const doSubmit=function () {
      if(userInfo.value.name!='' && userInfo.value.company!='' && userInfo.value.phone!=''){
        userService.userApply(userInfo.value).then(result =>{
          if(result=='success'){
            ElMessage({type: 'success', message: '提交成功'});
            showApply.value=false;
          }
          else{
            ElMessage({type: 'warning', message: result});
            showApply.value=true;
          }
        });
      }else{
        ElMessage({type: 'warning', message: '请输入必填项'});
      }
    }
    return {
      model, loginFromKey, onChange, doLogin, swagger, doWxLogin, doWxQrLogin, doStopWxQrLogin, wxQrLogin,
      siteName, siteEnName,doApply,showApply,userInfo,userInfoRules,doSubmit
    }


  },
  components: {},


}
</script>

<style scoped>
@import "../styles/css/login.css";
@import "../styles/css/icon/iconfont.css";

.login_btn_box .el-button {
  width: 45%;
  padding: 0;
}

.login_btn_box .wx_btn {
  background: #40E476;
  border-radius: 5px;
  border: none;
  color: #fff;
}
.login_btn_box .wx_btn.apply_btn{
  background: #e6a23c;
}

.el-input__inner {
  border-radius: 0.25rem;
  border: 0.0625rem solid rgba(255, 255, 255, 0.2);
  background: rgba(255, 255, 255, 0.2);
  height: 5rem;
  line-height: 5rem;
  padding: 0 0.9375rem;
}

.v-s-login-main {
  height: 16.375rem;
  width: 25rem;
}

.error {
  top: 20%;
  left: 22%;
  position: absolute;
  font-size: 0.75rem;
  color: #f56c6c;
}

.rem .el-checkbox__input .el-checkbox__inner {
  border: 1px solid white !important;
}

.rem {
  font-size: 0.1rem;
  color: #999999 !important;
}

.el-form-item {

  margin-bottom: 0.2rem !important;
}

.app {
  text-align: center;
  color: #2c3e50;
  width: 100%;
  height: 100%;
  /*margin-top: 1.25rem;*/
}

.v-bb .el-button.is-round {
  border-radius: 1.25rem;
  padding: 0.75rem 1.4375rem;
}

.v-bb .el-input {
  font-size: 0.875rem;
}

.v-bb .el-input::-webkit-scrollbar {
  width: 0.375rem;
}

.v-bb .el-input-group__append, .v-bb .el-input-group__prepend {
  border: 0.0625rem solid #121820;
  border-radius: 0.25rem;
  padding: 0 1.25rem;
  width: 0.0625rem;
}

.v-bb .el-input__inner {
  border-radius: 0.25rem;
  border: 0.0625rem solid #121820;
  height: 2.5rem;
  line-height: 2.5rem;
  padding: 0 0.9375rem;
}

.v-bb .el-button {
  border: 0.0625rem solid #e6a23c;
  padding: 0.75rem 1.25rem;
  font-size: 0.875rem;
  border-radius: 0.25rem;
}

.v-bb .iconfont {
  font-size: 1rem;
}

.wel_input_box input {
  height: 4rem;
}

.kingfisher-login-input .wel_input_box .el-input-group__append, .kingfisher-login-input .wel_input_box .el-input-group__prepend {
  background: transparent !important;
  border: none !important;
}

.kingfisher-login-input .el-input__inner {
  background: rgba(255, 255, 255, 0.2) !important;
  border-color: rgba(255, 255, 255, 0.2) !important;

}

.kingfisher-login-input .el-button--warning {
  background: #01baff;
  border-radius: 5px;
  border: none;
}

.kingfisher-login-input input:-webkit-autofill {
  background-color: rgba(255, 255, 255, 0.2) !important;
  background-image: none !important;
  color: #ccc !important;
}
</style>
<style>
.kingfisher-login-input .el-input-group__append, .kingfisher-login-input .el-input-group__prepend {
  background: transparent;
  border: none;
}

.kingfisher-login-input .wel_input_box .el-input-group__append, .kingfisher-login-input .wel_input_box .el-input-group__prepend {
  background: rgba(255, 255, 255, 0.2) !important;
  color: #ccc;
  border: none !important;
}

.kingfisher-login-input .el-input__inner {
  border: 0.0625rem solid transparent !important;
  background: rgba(255, 255, 255, 0.2) !important;
  color: #ccc !important;
}

.kingfisher-login-input .el-input__prefix {
  width: 1rem;
}

.kingfisher-login-input .el-input__icon {
  width: 100%;
}

</style>
